import Events from 'components/Events';

function events() {
	return (
		<Events />
	)
}

export default events